"use strict";

var _ = require("underscore");
var moment = require("moment");
var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");
var SignalActions = require("app/shared/actions/signal-actions");

var ActivityTypeActions = Reflux.createActions({
  "selectType": {},
  "getSelectedTypeIds": {},
  "getActivityTypes": {children: ["completed","failed"]},
});

ActivityTypeActions.getActivityTypes.listen(function(previouslySavedFilters){

  var params = { type: true };

  agendorAPI.get("/metrics", params, function (activityTypes, response) {
    if(response && response.ok){
      this.completed(activityTypes, previouslySavedFilters);
    } else {
      var errorMsg = "Houve um problema na requisição de métricas.";
      this.failed(errorMsg);
      SignalActions.show({ message: errorMsg, type: "warning" });
    }
  }.bind(this));
});


module.exports = ActivityTypeActions;



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/activity-type-actions.js